"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessId = void 0;
const next13_utils_common_get_cookie_1 = __importDefault(require("@gerenciatd/next13.utils.common.get-cookie"));
const next13_utils_common_set_cookie_1 = __importDefault(require("@gerenciatd/next13.utils.common.set-cookie"));
const getSessId = () => {
    let sessId = (0, next13_utils_common_get_cookie_1.default)("_mc_sessid");
    if (!sessId) {
        sessId = `${new Date().getTime()}`;
        (0, next13_utils_common_set_cookie_1.default)("_mc_sessid", sessId, undefined, ".movistar.es");
    }
    return sessId;
};
exports.getSessId = getSessId;
exports.default = exports.getSessId;
//# sourceMappingURL=index.js.map